{
  "_comment": "Словарь типов документов спортсмена для диалога «Документы» в секции «Спортсмены». Пока в диалоге показываются ВСЕ типы этого словаря: по каждому типу можно загрузить один файл или удалить загруженный. Правила, которые будут скрывать часть типов в зависимости от полей спортсмена и организации, появятся в будущих версиях; возраст спортсмена на состав строк не влияет — он влияет только на выбор бланка согласия (до 18 лет согласие дают родители, с 18 лет — сам спортсмен). Правки — только организатору; id участвует в ключе хранения файла (documents/{userId}/{athleteId}/{docId}), поэтому менять существующие id нельзя. Бланки согласия для скачивания — статические PDF в src/frontend (родителей — parental-consent-form.pdf, совершеннолетних — adult-consent-form.pdf); имена файлов заданы в src/frontend/application.ts (PARENTAL_CONSENT_FORM_HREF / ADULT_CONSENT_FORM_HREF).",
  "version": 3,
  "documents": [
    {
      "id": "insurance",
      "title": "Страховка"
    },
    {
      "id": "medical-certificate",
      "title": "Медицинская справка"
    },
    {
      "id": "parental-consent",
      "title": "Согласие на соревнования"
    }
  ]
}
